import ga4Tracker from './ga4'
import gtmTracker from './gtm'

export default function(config) {
    switch (config.script_type) {
        case 'ga':
            return ga4Tracker
        case 'gtag':
            return gtmTracker
        default:
            return
    }
}
